module.exports = fox._r("images/404-bg.jpg", __webpack_public_path__ + "images/404-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/404-bg.jpg
// module id = 982
// module chunks = 4